import React from 'react'
import { number, string, array, bool, func } from 'prop-types'
import withResults from '../hoc/withResults'
import { IMAGES } from '../utils/constants'
import ResultsContainer from '../components/results/Container'

const ScreensResultsImages = ({
  query = '',
  results,
  error,
  resultsAreLoading,
  requestResults,
  totalDocs,
  lastQueryUsed,
  ...rest
}) => {
  if (error) {
    return null
  }

  return (<ResultsContainer
    aggregationActive={IMAGES}
    isLoading={resultsAreLoading}
    query={query}
    lastQueryUsed={lastQueryUsed}
    results={results}
    totalCount={totalDocs}
    requestResults={requestResults}
    gridView
    isGridAble
    {...rest}
  />)
}

ScreensResultsImages.propTypes = {
  lastQueryUsed: string,
  query: string,
  site: string,
  results: array,
  error: bool,
  resultsAreLoading: bool,
  hasMore: bool,
  requestResults: func,
  pageStart: number,
  totalDocs: number
}

export default React.memo(withResults(ScreensResultsImages, IMAGES))